module.exports = __webpack_public_path__ + "static/media/projectPic5.6dce6ce0.png";